import React, { useEffect } from 'react'
import clsx from 'clsx';
// import Box from '@material-ui/core/Box'
// import Grid from '@material-ui/core/Grid'
import { Button, Icon, IconButton, InputAdornment, Popover, TextField, Checkbox, Box, Grid, CircularProgress } from '@mui/material'
// import { NavigateBefore, NavigateNext } from '@material-ui/icons'
import moment from 'moment'
import helper from '@utils/helper'
import filterIcon from '@assets/icons/tools/filter.svg'
import download_icon from '@assets/icons/download.svg'
import FileSaver from "file-saver";
import { NavigateBefore, NavigateNext } from '@mui/icons-material';
// import CircularProgress from "@material-ui/core/CircularProgress";
import styles from "./style.module.scss";
import { Search } from '@mui/icons-material';
import fetch from '@utils/fetch';
const AccountToolbar = ({
    onSubmit,
    dateFilter,
    setDateFilter,
    submitRetake,
    typeRetake,
    setTypeRetake,
    createQrCode,
    anchorEl,
    setAnchorEl,
    inputValue,
    setInputValue,
    setServiceFilter
}) => {
    // const styles = useStyles();
    const [email, setEmail] = React.useState('');
    const [textDynamicId, setTextDynamicId] = React.useState('');
    const [url, setUrl] = React.useState('');
    const [anchorFilterEl, setAnchorFilterEl] = React.useState(null);
    const [btnSubmit, setBtnSubmit] = React.useState(false)

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const handlePopoverFilterOpen = (event) => {
        event.stopPropagation();
        event.preventDefault();
        setAnchorFilterEl(event.currentTarget);
    };

    const handlePopoverFilterClose = () => {
        setAnchorFilterEl(null);
    };

    useEffect(() => {
        if (helper.getQueryParam('email')) {
            setInputValue(helper.getQueryParam('email'));
        }
    }, [helper.getQueryParam('email')])

    const open = Boolean(anchorEl);
    const openFilter = Boolean(anchorFilterEl);
    const [stateFilter, setStateFilter] = React.useState({
        free: false,
        premium: false,
        advanced: false,
        professional: false,
        custom: false
    });

    const handleChange = (event) => {
        setStateFilter({
            ...stateFilter,
            [event.target.name]: event.target.checked,
        });
    };

    const { free, premium, advanced, professional, custom } = stateFilter;

    const handleFilter = () => {
        let filter = []
        for (let i in stateFilter) {
            if (stateFilter[i]) filter.push(i)
        }
        if (filter?.length > 0) {
            setServiceFilter(filter.join(","))
        }
        handlePopoverFilterClose()
    }

    const downloadFile = async () => {
        setBtnSubmit(true)
        const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";
        fetch(`/api/billing/transactions/downloads/download`, {
            method: 'GET',
            secure: true
        }).then(res => {
            return res.arrayBuffer();
        })
            .then(data => {
                if (data) {
                    const tmp = new Blob([data], { type: fileType });
                    FileSaver.saveAs(tmp, "All_List_Premium" + fileExtension);
                }
                setBtnSubmit(false)
            })
            .catch((e) => setBtnSubmit(false))
    }

    return (
        <div className={styles.root}>
            <form onSubmit={onSubmit} id="search_box" style={{ width: '100%', padding: "0px 50px" }}>
                <Grid
                    container
                    alignItems='flex-end'
                    justifyContent='space-between'
                    className={styles.toolbarContainer}
                    spacing={2}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center' }} mb={1}>
                        <TextField
                            className={styles.searchBar}
                            placeholder='Nhập từ khóa bạn đang tìm kiếm'
                            value={inputValue}
                            variant="standard"
                            onChange={(e) => setInputValue(e.target.value)}
                            sx={{
                                '& .MuiInput-underline:before': { borderBottomColor: '#41B60B' },
                                '& .MuiInput-underline:after    ': { borderBottomColor: '#41B60B' },
                                '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: '#41B60B' },
                                '& .MuiInput-underline.Mui-focused:before': { borderBottomColor: '#41B60B' },
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <IconButton type="submit" className={styles.buttonSearch}>
                                            <Search className={styles.iconSearch}>search</Search>
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            name="email"
                        />
                        <img onClick={handlePopoverFilterOpen} style={{ cursor: 'pointer', width: "30px" }} src={filterIcon} alt='filter-icon' />
                    </Box>

                    <Box sx={{ display: 'flex', '& button': { margin: '0px 5px', padding: '5px 15px', textTransform: 'none' } }}>
                        <Button style={{ color: "#5D5D5D", backgroundColor: "#EFF0F0" }}
                            startIcon={btnSubmit ? <CircularProgress color="inherit" style={{ height: "20px", width: "20px" }} /> : <img src={download_icon} alt="download-icon" />}
                            variant="outlined"
                            size='small'
                            className={styles.btnToday}
                            onClick={downloadFile}
                            disabled={btnSubmit}
                        >
                            Tải xuống
                        </Button>
                        <Button style={{ background: "#41B60B" }} variant="contained" size='small' onClick={handlePopoverOpen} className={styles.btnNoPadding}>Tạo lại QRCode</Button>
                        <Button style={{ color: "#41B60B" }} variant="outlined"
                            className={styles.btnToday}
                            onClick={() => setDateFilter(moment(dateFilter).subtract(1, 'day').format('YYYY-MM-DD'))}
                        >
                            <NavigateBefore />
                        </Button>
                        <Button style={{ color: "#41B60B" }} variant="outlined" size='small'
                            className={styles.btnToday}
                            onClick={(e) => {
                                setDateFilter(moment().format('YYYY-MM-DD'))
                            }}
                        >
                            {"Hôm nay"}
                        </Button>
                        <Button variant="outlined" className={styles.btnToday}>
                            <TextField
                                sx={{ "& fieldset": { border: 'none' } }}
                                id="date"
                                label=""
                                type="date"
                                value={dateFilter}
                                className={styles.dateField}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onChange={(e) => {
                                    setDateFilter(e.target.value)
                                }}
                            />
                        </Button>
                        <Button style={{ color: "#41B60B" }} variant="outlined"
                            className={styles.btnToday}
                            onClick={() => setDateFilter(moment(dateFilter).add(1, 'day').format('YYYY-MM-DD'))}
                        >
                            <NavigateNext />
                        </Button>
                    </Box>

                    <Popover
                        id="mouse-over-popover"
                        className={styles.popover}
                        styles={{
                            paper: styles.paper,
                        }}
                        open={open}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        onClose={handlePopoverClose}
                        disableRestoreFocus
                    >
                        <Box sx={{ width: '468px', padding: '32px' }}>
                            <Box sx={{ width: '100%', textAlign: 'center', fontSize: '18px', color: '#131313', mb: 3 }}>Lấy lại code cho user</Box>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                '& .MuiInputBase-root': {
                                    margin: '17px auto',
                                    width: '100%',
                                    fontSize: '14px'
                                }
                            }}
                            >
                                <TextField value={email} onChange={(e) => setEmail(e.target.value)} placeholder='Email' />
                                <TextField value={textDynamicId} onChange={(e) => setTextDynamicId(e.target.value)} placeholder='ID code động' />
                                {typeRetake && <span style={{ color: '#E71919', fontWeight: '500' }}>ID động này không tồn tại!! Tạo QR code mới ??</span>}
                                {typeRetake && <TextField value={url} onChange={(e) => setUrl(e.target.value)} placeholder='URL cuối' />}
                            </Box>
                            <Box sx={{
                                display: 'flex', justifyContent: 'flex-end', '& button': {
                                    margin: '0px 5px',
                                    textTransform: 'none'
                                }
                            }}>
                                <Button variant='contained' style={{ background: "#E0E0E0", color: "black" }} size='large' onClick={() => {
                                    setAnchorEl(null)
                                    setEmail(null)
                                    setTextDynamicId(null)
                                    setTypeRetake(false)
                                }}>Hủy</Button>
                                <Button variant='contained' style={{ background: "#41B60B" }} size='large'
                                    onClick={() => {
                                        if (typeRetake) {
                                            createQrCode({ email, id: textDynamicId, url })
                                        } else {
                                            submitRetake({ email, id: textDynamicId })
                                        }
                                    }}
                                >
                                    Tạo code
                                </Button>
                            </Box>
                        </Box>
                    </Popover>

                    <Popover
                        id="mouse-over-popover"
                        className={styles.popover}
                        styles={{
                            paper: styles.paper,
                        }}
                        open={openFilter}
                        anchorEl={anchorFilterEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        onClose={handlePopoverFilterClose}
                        disableRestoreFocus
                    >
                        <Box sx={{ width: '360px', padding: '32px' }}>
                            <Box sx={{ width: '100%', textAlign: 'left', fontSize: '18px', color: '#131313', mb: 3 }}>
                                Lọc theo gói dịch vụ
                            </Box>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'row',
                            }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', width: '50%', flexDirection: 'row', justifyContent: 'flex-start' }}>
                                    <Checkbox sx={{
                                        color: "black",
                                        '&.Mui-checked': {
                                            color: "#41B60B",
                                        },
                                    }} onChange={handleChange} checked={free} name='free' ></Checkbox>
                                    <Box sx={{ ml: 1 }} xs={12}>Free</Box>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', width: '50%', flexDirection: 'row', justifyContent: 'flex-start' }}>
                                    <Checkbox sx={{
                                        color: "black",
                                        '&.Mui-checked': {
                                            color: "#41B60B",
                                        },
                                    }} onChange={handleChange} checked={premium} name='premium' ></Checkbox>
                                    <Box sx={{ ml: 1 }} xs={12}>Lite</Box>
                                </Box>
                                
                            </Box>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'row',
                            }}
                            >
                               <Box sx={{ display: 'flex', alignItems: 'center', width: '50%', flexDirection: 'row', justifyContent: 'flex-start' }}>
                                    <Checkbox sx={{
                                        color: "black",
                                        '&.Mui-checked': {
                                            color: "#41B60B",
                                        },
                                    }} onChange={handleChange} checked={advanced} name='advanced' ></Checkbox>
                                    <Box sx={{ ml: 1 }} xs={12}>Advanced</Box>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', width: '50%', flexDirection: 'row', justifyContent: 'flex-start' }}>
                                    <Checkbox sx={{
                                        color: "black",
                                        '&.Mui-checked': {
                                            color: "#41B60B",
                                        },
                                    }} onChange={handleChange} checked={professional} name='professional' ></Checkbox>
                                    <Box sx={{ ml: 1 }} xs={12}>Professional</Box>
                                </Box>
                            </Box>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'row',
                            }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', width: '50%', flexDirection: 'row', justifyContent: 'flex-start' }}>
                                    <Checkbox sx={{
                                        color: "black",
                                        '&.Mui-checked': {
                                            color: "#41B60B",
                                        },
                                    }} onChange={handleChange} checked={custom} name='custom' ></Checkbox>
                                    <Box sx={{ ml: 1 }} xs={12}>Custom</Box>
                                </Box>

                            </Box>
                            <Box sx={{
                                display: 'flex', mt: 6, justifyContent: 'flex-end', '& button': {
                                    margin: '0px 5px',
                                    padding: '5px 45px',
                                    textTransform: 'none'
                                }
                            }}>
                                <Button onClick={handleFilter} variant='contained' style={{ background: "#41B60B" }} size='large'>Lọc</Button>
                            </Box>
                        </Box>
                    </Popover>
                </Grid>
            </form>
        </div>
    )
}

AccountToolbar.propTypes = {}

AccountToolbar.defaultProps = {}

export default AccountToolbar;